import { ChangeEventHandler, useCallback, useEffect, useMemo, useState } from "react";
import { SelectInput } from "components/inputs/SelectInput/SelectInput";
import classes from "./SelectDate.module.scss";

interface IProps {
  onChange: (value: number) => void;
}

const COUNT_YEARS = 100;
const COUNT_MONTHS = 12;
const START_YEAR = new Date().getFullYear();
const START_MONTH = new Date().getMonth();
const START_DAY = new Date().getDate();
const MS_IN_SEC = 1000;

const SelectDate = (props: IProps) => {
  const { onChange } = props;

  const [day, setDay] = useState(START_DAY);
  const [month, setMonth] = useState(START_MONTH);
  const [year, setYear] = useState(START_YEAR);

  const calcCountDays = () => {
    return new Date(year, month, 0).getDate();
  };

  const [maxOffsetDays, setMaxOffsetDays] = useState(calcCountDays);

  const calcDays = () => {
    const items = [];
    for (let i = 1; i <= maxOffsetDays; i++) {
      items.push(i);
    }

    return items;
  };

  const [allDays, setAllDays] = useState<number[]>(calcDays);

  const months = useMemo(() => {
    const items = [];

    for (let i = 0; i < COUNT_MONTHS; i++) {
      items.push(new Date(START_YEAR, i).toLocaleString("default", { month: "long" }));
    }

    return items;
  }, []);

  const years = useMemo(() => {
    const items = [];

    for (let x = 0; x <= COUNT_YEARS; x++) {
      items.push(START_YEAR - x);
    }

    return items;
  }, []);

  const handleDate: ChangeEventHandler<HTMLSelectElement> = useCallback((e) => {
    setDay(Number(e.target.value));
  }, []);

  const handleMonth: ChangeEventHandler<HTMLSelectElement> = useCallback((e) => {
    setMonth(Number(e.target.value));
  }, []);

  const handleYear: ChangeEventHandler<HTMLSelectElement> = useCallback((e) => {
    setYear(Number(e.target.value));
  }, []);

  useEffect(() => {
    setMaxOffsetDays(calcCountDays());
    // eslint-disable-next-line
  }, [month, year])

  useEffect(() => {
    setAllDays(calcDays());
    // eslint-disable-next-line
  }, [maxOffsetDays])

  useEffect(() => {
    const date = Math.round(new Date(year, month, day).getTime() / MS_IN_SEC);
    onChange(date);
    // eslint-disable-next-line
  }, [day, month, year])

  return (
    <div className={classes.Container}>
      <SelectInput onChange={handleDate} label="Day">
        {allDays.map(el => (
          <option value={el.toString()} key={el}>{el}</option>
        ))}
      </SelectInput>

      <SelectInput onChange={handleMonth} label="Month">
        {months.map((el, index) => (
          <option value={index.toString()} key={index}>{ el }</option>
        ))}
      </SelectInput>

      <SelectInput onChange={handleYear} label="Year">
        {years.map(el => (
          <option value={el} key={el}>{el}</option>
        ))}
      </SelectInput>
    </div>
  );
};

export default SelectDate;
